import { render, staticRenderFns } from "./listOfError.vue?vue&type=template&id=413a2554&"
import script from "./listOfError.vue?vue&type=script&lang=js&"
export * from "./listOfError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports